import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import {
  FETCH_PROJECT_ROUTES,
  FETCH_PROJECT_ROUTES_FAILURE,
  FETCH_PROJECT_ROUTES_SUCCESS,
  FETCH_PROJECT_STRUCTURE,
  FETCH_PROJECT_STRUCTURE_FAILURE,
  FETCH_PROJECT_STRUCTURE_SUCCESS,
  PROJECT_ROUTES_CLEAR_STATE,
  PROJECT_ROUTES_SELECTION_CHANGED,
  ROUTE_TREE_THUMBNAIL_DETAILS_CHANGED,
  projectRoutesCacheKey,
  PROJECT_ROUTES_BULK_DELETE,
  PROJECT_ROUTES_BULK_DELETE_SUCCESS,
  PROJECT_ROUTES_BULK_DELETE_FAILURE,
  SET_VIEW_ROUTES_POSITION,
} from '@Pages/RetroSynthesis/ProjectRoutes/constants';
import { noCache } from '@Utils/Network';
import namespacedCache from '@Services/NamespacedCache';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import {
  PROJECT_ACCESS_FAILURE_ERROR_NUMBER,
  PROJECT_ACCESS_FAILURE_STATUS_CODE,
} from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';

export const fetchProjectRoutesAction = (projectId, params, history) => async (dispatch) => {
  dispatch({ type: FETCH_PROJECT_ROUTES });
  try {
    const cacheKey = projectRoutesCacheKey(projectId, params);
    let result = namespacedCache.getByKey(cacheKey);

    if (!result) {
      result = await MessageBroker.send(RequestUrls.rsProjectRoutes, { ...params, projectId }, noCache());
      namespacedCache.setByKey(cacheKey, result);
    }

    dispatch({
      type: FETCH_PROJECT_ROUTES_SUCCESS,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: FETCH_PROJECT_ROUTES_FAILURE,
      payload: e,
    });
    if (e.errorNumber === PROJECT_ACCESS_FAILURE_ERROR_NUMBER && e.statusCode === PROJECT_ACCESS_FAILURE_STATUS_CODE) {
      // project access error - goto project page
      history.push(RsRoute.PROJECTS_LIST);
    }
  }
};

export const projectRoutesSelectionChanged = (payload = []) => ({
  type: PROJECT_ROUTES_SELECTION_CHANGED,
  payload,
});

export const fetchProjectStructureAction = (projectId) => async (dispatch) => {
  dispatch({ type: FETCH_PROJECT_STRUCTURE });
  try {
    const result = await MessageBroker.send(RequestUrls.rsProjectStructure, { projectId }, noCache());
    dispatch({
      type: FETCH_PROJECT_STRUCTURE_SUCCESS,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: FETCH_PROJECT_STRUCTURE_FAILURE,
      payload: e,
    });
  }
};

export const projectRouteTreeTooltipDataChanged = (target, data) => ({
  type: ROUTE_TREE_THUMBNAIL_DETAILS_CHANGED,
  payload: { target, data },
});

export const projectRouteClearStateAction = () => ({
  type: PROJECT_ROUTES_CLEAR_STATE,
});

// eslint-disable-next-line consistent-return
export const fetchProjectRoutesLightweightAction = async (projectId, params) => {
  try {
    const payload = { ...params, projectId };
    if (params.selectedItem) {
      payload.routeId = params.selectedItem;
      delete payload.selectedItem;
    }
    return await MessageBroker.send(RequestUrls.rsProjectRoutesLightweight, payload, { cache: false });
  } catch (e) {
    Logger.info('RT Project Route - fetch routes lightweight error', e);
  }
};

export const bulkDeleteProjectRoutesAction = (projectId, routeIds) => async (dispatch) => {
  dispatch({ type: PROJECT_ROUTES_BULK_DELETE });
  try {
    const response = await MessageBroker.send(RequestUrls.rsProjectsBulkDeleteRoutes, { projectId }, noCache(), routeIds);
    namespacedCache.removeByKey(projectRoutesCacheKey(projectId));
    dispatch({
      type: PROJECT_ROUTES_BULK_DELETE_SUCCESS,
      payload: response,
      projectId,
      routeIds,
    });
  } catch (error) {
    dispatch({
      type: PROJECT_ROUTES_BULK_DELETE_FAILURE,
      payload: error,
    });
  }
};

export const setViewRoutesPositionAction = (position) => ({
  type: SET_VIEW_ROUTES_POSITION,
  payload: position,
});
